/**
 * Lista única de auth_type permitidos em parâmetros `service-account-selector` de custom nodes.
 * Manter idêntico a `backend-api/constants/custom-node-service-account-auth-types.js`.
 */
export const DEFAULT_SERVICE_ACCOUNT_AUTH_TYPES = [
    "bearer_token",
    "http_basic",
    "jwt",
    "oauth2",
    "google_service_account_json",
    "aws_access_key",
    "sankhya_partner_id",
    "omie_erp",
    "floui_token",
    "gpg_auth",
    "anymarket",
    "brandshub",
    "sap_b1_service_layer"
]
